var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-text",attrs:{"id":"EmojiButton","title":_vm.$t('sectionButtonEmoji.clickToChooseEmoji')}},[_c('i',{staticClass:"far fa-smile"})])}
var staticRenderFns = []

export { render, staticRenderFns }